export const SUPPLIER_REGISTRATION_PATTERNS = {
  registrationNumber: /^SV-\d{7,20}$/,
};
